import type { ChatMessage } from '@/features/chat-stream/types'
import { httpClient } from '@/shared/api/httpClient'

import type {
  CreatePlayIntentRequest,
  PlayIntent,
  PlayIntentChatSummary,
  PlayIntentGroup,
  PlayIntentWindow,
} from '../types/playIntent.types'

export const playIntentsApi = {
  windows: (): Promise<PlayIntentWindow[]> =>
    httpClient.get<PlayIntentWindow[]>('/play-intents/windows').then((r) => r.data),

  groups: (cityCode: string): Promise<PlayIntentGroup[]> =>
    httpClient
      .get<PlayIntentGroup[]>('/play-intents/groups', { params: { cityCode } })
      .then((r) => r.data),

  create: (body: CreatePlayIntentRequest): Promise<PlayIntent> =>
    httpClient.post<PlayIntent>('/play-intents', body).then((r) => r.data),

  withdraw: (id: number): Promise<void> =>
    httpClient.delete(`/play-intents/${id}`).then(() => undefined),

  mine: (): Promise<PlayIntent[]> =>
    httpClient.get<PlayIntent[]>('/me/play-intents').then((r) => r.data),

  // ── Chat del grupo (spec 2026-10-12), entrando por mis ganas ──────────

  chatMessages: (intentId: number): Promise<ChatMessage[]> =>
    httpClient.get<ChatMessage[]>(`/me/play-intents/${intentId}/messages`).then((r) => r.data),

  sendChatMessage: (intentId: number, content: string): Promise<ChatMessage> =>
    httpClient
      .post<ChatMessage>(`/me/play-intents/${intentId}/messages`, { content })
      .then((r) => r.data),

  /** «Salir del chat» del grupo: solo con la mesa ya conseguida (409 si aún busco partida). */
  leaveChat: (intentId: number): Promise<void> =>
    httpClient.post(`/me/play-intents/${intentId}/chat/leave`).then(() => undefined),

  markChatRead: (intentId: number): Promise<void> =>
    httpClient.post(`/me/play-intents/${intentId}/messages/mark-read`).then(() => undefined),

  myChats: (): Promise<PlayIntentChatSummary[]> =>
    httpClient.get<PlayIntentChatSummary[]>('/me/play-intent-chats').then((r) => r.data),
}
